let headerHeight = $('#header_wrap').outerHeight();
document.documentElement.style.setProperty('--headerHeight', `${headerHeight}px`);
window.addEventListener('resize', () => {
    let headerHeight = $('#header_wrap').outerHeight();
    document.documentElement.style.setProperty('--headerHeight', `${headerHeight}px`);
});

function pageInit(){

  //Homepage - Check for white first block
  var $firstSection = $('#MainContent .shopify-section').first();
  if ( $firstSection.find('.home_section, .block').hasClass('full_image') ) {
    if ( $firstSection.find('.full_image').hasClass('white') ) {
      $('#header_wrap').addClass('white');
    }
  }

  //Product Slideshow - Mob
  const swiper = new Swiper('.product_images_mob .swiper-container', {
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    }
  });

  //Collection Filters
  $('.filter_select').change(function(){
    var $filters = [];
    var $availability = $('#availability_filter').val();
    var $type = $('#type_filter').val();
    var $stone = $('#stone_filter').val();
    if ($availability != '') {
      $filters.push($availability);
    }
    if ($type != '') {
      $filters.push($type);
    }
    if ($stone != '') {
      $filters.push($stone);
    }
    $filterString = $('#current_collection_url').html() + '/' + $filters.join('+');
    window.location.href = $filterString;
  })


  //Load Cart into drawer
  $('#cart_contents').load('/cart #cart_load', function(){});

  //Ajax Remove Button
  $('body').on('click','.remove_link',function(event){
    event.preventDefault();
    var $variant = $(this).attr('data-variant');
    $('#cart_contents').addClass('loading');
    $('.cart_page_wrapper#cart_drawer').css('opacity','0.5');
    
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+$variant+']=0',
      dataType: 'json',
      success: function() {
        //update cart page
        $('.cart_page_wrapper#cart_drawer').load('/cart #cart_load', function(){
          $('.cart_page_wrapper#cart_drawer').css('opacity','1');
        });
        
        //Update Mini Cart
        $('#cart_contents').load('/cart #cart_load', function(){
          $('#cart_contents').removeClass('loading');
        });

        //Update Cart Count
        jQuery.getJSON('/cart.js', function(cart) {
          $('.cart-count').html(cart.item_count);
        } );
      }
    });
  });

  //Add/Remove one buttons in cart
  $('body').on('click','.add_one, .minus_one',function(event){
    event.preventDefault();
    var $variant = $(this).attr('data-variant');
    var $qty = $(this).attr('data-qty');
    $('#cart_contents').addClass('loading');
    $('.cart_page_wrapper#cart_drawer').css('opacity','0.5');
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+$variant+']='+$qty,
      dataType: 'json',
      success: function() {
         //update cart page
           $('.cart_page_wrapper#cart_drawer').load('/cart #cart_load', function(){
            $('.cart_page_wrapper#cart_drawer').css('opacity','1');
          });
        
        //Update Mini Cart
        $('#cart_contents').load('/cart #cart_load', function(){
          $('#cart_contents').removeClass('loading');
        });

        //Update Cart Count
        jQuery.getJSON('/cart.js', function(cart) {
          $('.cart-count').html(cart.item_count);
        } );
      }
    });
  });

  //Are you sure? Cart button
  $('body').on('click','.toggle_sure',function(event){
    event.preventDefault();
    $(this).parents('.cart_item').find('.remove_sure').toggleClass('active');
  });

  //Product Thumbnail Scroll
  $('.product_image_thumb').click(function(){
    var $target = $(this).attr('data-target');
    $('html, body').animate({
        scrollTop: ($($target).offset().top - 100)
    },500);
  })

  //Shop Submenu
  if ( Modernizr.touchevents ) {
    //Shop/About Submenus
    $('#shop_link').click(function(e){
      e.preventDefault();
      $('#shop_menu').toggleClass('show');
      $('#about_menu').removeClass('show');
    });
    $('#about_link').click(function(e){
      e.preventDefault();
      $('#about_menu').toggleClass('show');
      $('#shop_menu').removeClass('show');
    });
    
  } else {
    //Shop Menu
    $('li.has-submenu').mouseenter(function(){
      $(this).find('.submenu').addClass('show');
      $(this).siblings().find('.submenu').removeClass('show');
    });
    $('#site_header').mouseleave(function(){
      $('.submenu').removeClass('show');
    });
  }

  //Toggle Search
  $('.toggle_search').click(function(e){
    e.preventDefault();
    $('#menu_search').toggleClass('show');
    $('#header_wrap').toggleClass('search-open');
  });

  //Mob Menu Submenus
  $('.toggle_submenu').click(function(e){
    e.preventDefault();
    var $this = $(this);
    $this.toggleClass('open');
    $this.next('.sub-menu').slideToggle(200);
  });

  //Toggle Submenu
  $('.toggle_mob_menu').click(function(e){
    e.preventDefault();
    $('#mob_menu, #mask').toggleClass('show');
  });

  //Toggle Submenu
  $('body').on('click','.toggle_cart', function(e){
    e.preventDefault();
    $('#cart_drawer, #mask').toggleClass('show');
    $('.rodal-close').click();
  });

  //Wishlist View Cart button
  $('body').on('click','.uwl-wishlist-cart-btn', function(e){
    e.preventDefault();
    $('#cart_contents').load('/cart #cart_load', function(){
      $('#cart_drawer, #mask').toggleClass('show');
      $('.rodal-close').click();
      //Update Cart Count
      jQuery.getJSON('/cart.js', function(cart) {
        $('.cart-count').html(cart.item_count);
      } );
    });
  });

  //Close Menu/cart
  $('#mask').click(function(){
    $('#mob_menu, #cart_drawer, #mask').removeClass('show');
  })

  //Animate In
  $('.animate-in:in-viewport').addClass('visible');

  //Collection Infinite Scroll
  $('#collection_load').infiniteScroll({
    path: '.next a',
    append: '.product_thumb',
    history: false,
  });

  //Lightboxes
  $('.product_images a').simpleLightbox({
    history: false,
    animationSpeed: 150
  });

  //Article Images
  $('.article_content img').each(function(){
    var $this = $(this);
    var $alt = $this.attr('alt');
    $this.wrap("<div class='article_content_image'></div>");
  });
  $('.article_content_image').each(function(){
    var $this = $(this);
    var $alt = $(this).find('img').attr('alt');
    console.log($alt);
    if ( $alt != '' ) {
      console.log($alt);
      $this.append("<div class='article_image_caption'>" + $alt + "</div>");
    }
  });

  //Product Tabs
  $('.tab_title').click(function(){
    $('.product_tab').removeClass('open');
    $(this).parents('.product_tab').toggleClass('open');
  });

  //Materials Page
  $('.material_list_title .title').click(function(){
    var $target = $(this).parent().attr('data-target');
    $($target).addClass('active').siblings().removeClass('active');
    $(this).parent().addClass('active').siblings().removeClass('active');
    setTimeout(function(){
      $('html, body').animate({
        scrollTop: ($($target).offset().top - 150)
      },500);
    },500);
  });
  $('.material_list_title .close').click(function(){
    $('.material_list_title, .material_content').removeClass('active');
  });
  $('.material_content .swiper-container').each(function(){
    var $this = $(this);
    var $materialSwiper = new Swiper($this, {
      observer: true,
      observeParents: true,
      loop: true,
      watchOverflow:true,
      autoHeight: true,
      pagination: {
        el: $this.find('.material-pagination'),
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        }
      },
      on: {
        slideChangeTransitionStart: function(){
          var $caption = $this.find('.swiper-slide-active .slide-description').html();
          $this.parents('.material_content').find('.description').html($caption);
        }
      }
    })
  })

  //FAQs
  $('.faq-item .question').click(function(){
    $(this).parents('.faq-item').toggleClass('open');
  });

  //Site Popup
  if ( Cookies.get('seen-popup') ) {
  } else {
    $('#site_popup').removeClass('closed');
  }
  $('#site_popup .close').click(function(){
    $('#site_popup').addClass('closed');
    Cookies.set('seen-popup', 'seen', { expires: 1 });
  });

}

$(document).ready(function(){
  pageInit();
});

$(window).scroll(function(){
  $('.animate-in:in-viewport').addClass('visible');
  if ( $(document).scrollTop() > 5 ) {
    $('#header_wrap').addClass('scrolled');
  } else {
    $('#header_wrap').removeClass('scrolled');
  }
})